export default __webpack_public_path__ + "static/media/1.c2b528f0.jpeg";